module.exports = {
      id: "spotify-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "svg-sprite-39dbc991ee8a2ec1b35aeef6495011e2.svg#spotify",
      toString: function () {
        return this.url;
      }
    }